import React, { useEffect, useState } from "react";
import Particles, { initParticlesEngine } from "@tsparticles/react";
import { loadSlim } from "@tsparticles/slim";

const NetworkBackground = () => {
  const [init, setInit] = useState(false);

  useEffect(() => {
    initParticlesEngine(async (engine) => {
      await loadSlim(engine);
    }).then(() => {
      setInit(true);
    });
  }, []);

  if (!init) {
    return null;
  }

  return (
    <div style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 0, overflow: "hidden" }}>
      <Particles
        id="tsparticles"
        options={{
          background: {
            color: { value: "transparent" },
          },
          fpsLimit: 60,
          interactivity: {
            events: {
              onHover: { enable: true, mode: "grab" },
              resize: true,
            },
            modes: {
              grab: { distance: 200, links: { opacity: 0.8 } },
            },
          },
          particles: {
            color: { value: "#00f0ff" },
            links: {
              color: "#00f0ff",
              distance: 120,
              enable: true,
              opacity: 0.25,
              width: 1,
            },
            move: {
              direction: "none",
              enable: true,
              outModes: { default: "bounce" },
              random: true,
              speed: 0.8,
              straight: false,
            },
            number: {
              density: { enable: true, area: 1000 },
              value: 80,
            },
            opacity: {
              value: 0.5,
              random: true,
              anim: { enable: true, speed: 1, sync: false }
            },
            shape: { type: "circle" },
            size: {
              value: { min: 1, max: 2 },
            },
          },
          detectRetina: true,
        }}
        style={{ width: "100%", height: "100%" }}
      />
    </div>
  );
};

export default NetworkBackground;
